export default __webpack_public_path__ + "static/media/element_70.8e38d34b.webp";